import { useStore } from "../StoreContext";

const WhatsappButton = () => {
  const { storeData } = useStore();

  const numero =
    storeData?.paginaInicial?.whatsapp
      ?.replace(/\D/g, "") || "";

  if (!numero) return null;

  return (
    <a
      href={`https://wa.me/55${numero}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        right: "20px",
        bottom: "110px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        background: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        boxShadow: "0 4px 10px rgba(0,0,0,.2)",
        textDecoration: "none",
      }}
    >
      <i
        className="fa fa-whatsapp"
        style={{
          color: "#fff",
          fontSize: "36px",
        }}
      />
    </a>
  );
};

export default WhatsappButton;